import {
  and,
  ControlProps,
  RankedTester,
  rankWith,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";
import {
  FormDetailItem,
  FormDetailValue,
  FormDetailWrapper,
} from "../../messageType/contentType/FormContent.style";
import dayjs from "dayjs";
import { HHNConstants, RenderersUIType } from "@home-health-notify/domain";

const VisitPickerViewRenderer = ({ data }: ControlProps) => {
  const getVisitTime = () => {
    const startTime =
      data.visitStartTime &&
      dayjs(data.visitStartTime).format(HHNConstants.TIME_VIEW_FORMAT);
    const endTime =
      data.visitEndTime &&
      dayjs(data.visitEndTime).format(HHNConstants.TIME_VIEW_FORMAT);

    return startTime && endTime ? `${startTime} to ${endTime}` : "N/A";
  };

  return (
    <FormDetailWrapper data-testid="form-content-item">
      <FormDetailItem>Visit Time :</FormDetailItem>
      <FormDetailValue>{getVisitTime()}</FormDetailValue>
    </FormDetailWrapper>
  );
};

export const visitPickerTester: RankedTester = rankWith(
  5,
  and(uiTypeIs(RenderersUIType.VisitPicker)),
);

export default withJsonFormsControlProps(VisitPickerViewRenderer);
